import type * as ngRouter from '@uirouter/angularjs';

import { getOwnerUsername } from '@mode/shared/util-js';
import { OrganizationResource } from '@mode/legacy/data-access-model-js';

import { uiRouterComponent } from '@mode/workspace-settings/feature-members-angularjs';
import { GroupConnectionsComponent } from '../../group/group-connections/group-connections.component';
import { GroupSpacesComponent } from '../../group/group-spaces/group-spaces.component';
import { GroupComponent } from '../../group/group.component';
import { GroupsComponent } from '../groups.component';

export const GroupsPanelRoutesConfig = [
  '$stateProvider',
  '$urlRouterProvider',
  ($stateProvider, $urlRouterProvider: ngRouter.UrlRouterProvider) => {
    $urlRouterProvider.when('/organizations/:orgUsername/groups/:groupToken', [
      '$match',
      '$stateParams',
      '$state',
      function ($match, $stateParams, $state) {
        $state.transitionTo('org-settings.group.members', $match, {
          location: 'replace',
        });
      },
    ]);

    $stateProvider
      .state('org-settings.groups', {
        url: `/groups`,
        ...uiRouterComponent(GroupsComponent),
        resolve: {
          organization: GroupsPanelResolvers.organization,
          currentUserIsAdmin: GroupsPanelResolvers.currentUserIsAdmin,
          orgToken: GroupsPanelResolvers.orgToken,
          orgUsername: GroupsPanelResolvers.orgUsername,
        },
      })
      .state('org-settings.group', {
        url: `/groups/:groupToken`,
        abstract: true,
        ...uiRouterComponent(GroupComponent),
        resolve: {
          organization: GroupsPanelResolvers.organization,
          orgToken: GroupsPanelResolvers.orgToken,
          orgUsername: GroupsPanelResolvers.orgUsername,
          groupToken: GroupsPanelResolvers.groupToken,
        },
      })
      .state('org-settings.group.members', {
        url: '/members',
      })
      .state('org-settings.group.spaces', {
        url: `/spaces`,
        ...uiRouterComponent(GroupSpacesComponent),
      })
      .state('org-settings.group.connections', {
        url: `/connections`,
        ...uiRouterComponent(GroupConnectionsComponent),
      });
  },
];

namespace GroupsPanelResolvers {
  export const organization = [
    'AccountModel',
    async function (AccountModel: any): Promise<OrganizationResource> {
      const orgUsername = getOwnerUsername(window.document);
      return AccountModel.find({
        username: orgUsername,
        useEntryPath: true,
      });
    },
  ];

  export const currentUserIsAdmin = [
    'organization',
    async function (organization: any): Promise<boolean> {
      return Promise.resolve(organization.membershipType === 'admin');
    },
  ];

  export const orgToken = [
    'organization',
    function (org) {
      return org.token;
    },
  ];

  export const orgUsername = [
    'organization',
    function (org) {
      return org.username;
    },
  ];

  export const groupToken = [
    '$stateParams',
    function ($stateParams: ngRouter.StateParams) {
      return $stateParams.groupToken;
    },
  ];
}
